"use client";
import { useEffect, useState } from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "utils/constant";

/** Link store theo thiết bị (iOS → App Store, còn lại → Google Play). SSR mặc định Play. */
export default function useStoreUrl() {
  const [url, setUrl] = useState(PLAY_STORE_URL);
  useEffect(() => {
    if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) setUrl(APP_STORE_URL);
  }, []);
  return url;
}
